import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { TemplatesContent } from 'src/sections/@dashboard/templates/components/TemplatesContent';
import { TemplatesProvider } from 'src/sections/@dashboard/templates/context/TemplatesContext';
import { StyledContainer } from './styles';
// components
// ----------------------------------------------------------------------

export default function TemplatesPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title> Szablony | Vetsi</title>
      </Helmet>
      <StyledContainer disableGutters>
        <TemplatesProvider>
          <Stack
            sx={{
              minHeight: '560px',
              height: 1,
              gap: 2,
            }}
          >
            <Paper
              sx={{
                borderRadius: 2,
                boxShadow: theme.customShadows.z8,
                height: 1,
              }}
            >
              <Stack sx={{ height: 1, minHeight: '560px' }}>
                <TemplatesContent />
              </Stack>
            </Paper>
          </Stack>
        </TemplatesProvider>
      </StyledContainer>
    </>
  );
}
